const getPdfUrl = async (path: string) => {
  try {
    const attachmentResp = await fetch(path);
    if (attachmentResp.status !== 200) {
      throw new Error("Failure downloading PDF data");
    }
    const attachmentData = await attachmentResp.blob();
    const contentType = attachmentResp.headers.get("content-type");
    let pdfData = attachmentData;
    if (contentType !== "application/pdf") {
      // create a new Blob with correct MIME type.
      pdfData = new Blob([attachmentData], { type: "application/pdf" });
    }
    const _url = window.URL.createObjectURL(pdfData);
    return _url;
  } catch (e) {
    throw new Error("Error opening PDF", { cause: e });
  }
};

const getWordUrl = (path: string): string => {
  const url = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
    path
  )}`;
  return url;
};

export { getPdfUrl, getWordUrl };
